<template>
  <el-row id="header" type="flex" justify="space-between">
    <el-col>
      <div id="logo" style="display:inline;">
        <a href="/index">
          <img src="@/assets/img/logo-wite.png">
        </a>
      </div>
      <div style="display:inline;margin-left:200px">
        <el-switch
          v-model="$store.state.iscollapse"
          active-color="#ff4949"
          inactive-color="#13ce66"
        ></el-switch>
      </div>
    </el-col>
    <el-col style="width:120px">
      <el-menu
        :default-active="activeIndex"
        mode="horizontal"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b"
      >
        <el-submenu index="2">
          <template slot="title">{{name}}</template>
          <el-menu-item index="2-1" @click="loginout">注销</el-menu-item>
          <!-- <el-menu-item index="2-2">打开邮箱</el-menu-item>
          <el-menu-item index="2-3">账号登出</el-menu-item>-->
        </el-submenu>
      </el-menu>
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "0"
    };
  },
  props: {
    name: String
  },
  methods: {
    loginout: async function() {
      await this.$doGet("/api/login_out");
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style scoped>
#header {
  width: 100vw;
  background-color: #545c64;
  /* display: inline-block; */
  height: 63px;
}

#logo {
  height: 40px;
  width: 200px;
  padding: 0px;
}
#logo img {
  height: 29px;
  margin: auto 0px;
  position: relative;
  top: 17px;
  bottom: 0px;
  left: 55px;
  right: 0px;
}
.el-switch {
  margin-top: 15px;
  transform: rotate(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/mysys/Header.vue